export default "__VITE_ASSET__BAub1ciZ__"